:global(.ant-tag) {
  &.tag {
    margin-top: var(--space-1);
    margin-right: 0;
    text-align: center;
  }
}